import { useTranslation } from 'react-i18next'
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card'
import { Button } from '../../components/ui/button'
import { ShieldX } from 'lucide-react'
import { useNavigate } from '@tanstack/react-router'

export function AccessDeniedPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div className="min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8 bg-background">
      <Card variant="elevated" className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-destructive/10">
            <ShieldX className="h-6 w-6 text-destructive" />
          </div>
          <CardTitle className="text-xl font-semibold">
            {t('auth.accessDenied.title', 'Access Denied')}
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-center text-muted-foreground">
            {t('auth.accessDenied.message', 'You do not have permission to access this page.')}
          </p>
          <div className="flex flex-col gap-2">
            <Button onClick={() => navigate({ to: '/dashboard' })} className="w-full">
              {t('auth.accessDenied.goHome', 'Go to Dashboard')}
            </Button>
            <Button
              variant="outline"
              onClick={() => navigate({ to: '/profile' })}
              className="w-full"
            >
              {t('auth.accessDenied.goProfile', 'Go to Profile')}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
